export default __webpack_public_path__ + "static/newground-ba5838f04210af133cba730513a34082.png";